import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import { Link } from "gatsby";
import popularProject from "../../../../src/collections/blog/2024/09-07-ways-to-contribute/number-one-most-popular-project.png";
import * as React from 'react';
export default {
  BlogWrapper,
  Link,
  popularProject,
  React
};